import ToolStylus from './ToolStylus';
import Shortcut from '../utils/Shortcut';

class ToolStylusText extends ToolStylus {
  static toolName = 'Text';
  static shortcut = new Shortcut('T');

  static action({ controller }) {
    controller.actionSetStylus(controller.stylusText);
  }
}

export default ToolStylusText;
